import axios from 'axios'
import { MessageBox, Message } from 'element-ui'

const service = axios.create({
  baseURL:process.env.BASE_URL,
  // baseURL: process.env.NODE_ENV == 'production' ? 'https://ks.13398.com' : '', // url = base url + request url
  // withCredentials: true,
  timeout: 100000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['Authorization'] = getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code == 200) {
      return res
    } else {
      console.log(res.code)
      Message({
        showClose: true,
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.code === 401) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    // if (error.response.status === 401) {
    //   MessageBox.confirm('您的登录信息已过期,请重新登录!', '重新登录', {
    //     confirmButtonText: '去登录',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //   })
    // }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/server/request.js